import React, { FC } from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/react';
import { CliTemplateCard } from './CliTemplateCard';
import { useCliTemplatesQuery } from './useCliTemplatesQuery';
import { CliTemplate } from './types';
import s from './CliTemplatesSection.scss';
import { CliSkeletonCard } from './CliSkeletonCard';
import { useOnboardingPageBi } from '../../../hooks/useOnboardingPageBi';

export const CliTemplatesSection: FC<{
  onTemplateClick: (template: CliTemplate) => void;
  onStartWithoutPrompt: () => void;
}> = ({ onTemplateClick, onStartWithoutPrompt }) => {
  const { t } = useTranslation();
  const { templates, isLoading } = useCliTemplatesQuery();
  const { reportBiClick } = useOnboardingPageBi();

  const handleTemplateClick = (template: CliTemplate) => {
    reportBiClick({
      buttonName: 'Start with a template',
      value: template.title,
    });
    if (template.id === 'start-from-scratch-template') {
      onStartWithoutPrompt();
    } else {
      onTemplateClick(template);
    }
  };

  return (
    <Box direction="vertical" width="100%" align="center">
      <Box
        direction="vertical"
        width="100%"
        maxWidth="1200px"
        gap="24px"
        align="center"
      >
        <Box
          direction="vertical"
          gap="4px"
          align="center"
          textAlign="center"
          width="100%"
          className={s.sectionHeader}
        >
          <Heading size="medium">
            {t('devibe.onboarding.cli_templates.title')}
          </Heading>
          <Text secondary size="medium">
            {t('devibe.onboarding.cli_templates.subtitle')}
          </Text>
        </Box>
        <div className={s.templatesGrid}>
          {isLoading
            ? [...Array(4).keys()].map((data, key) => <CliSkeletonCard />)
            : templates.map((template) => (
                <CliTemplateCard
                  key={template.id}
                  template={template}
                  onClick={() => handleTemplateClick(template)}
                />
              ))}
        </div>
      </Box>
    </Box>
  );
};
